import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import translate from "react-i18next/dist/commonjs/translate";

/* eslint-disabled */
import logo from "../logo/cygate_logo.svg"; // eslint-disable-line import/namespace, import/default, import/no-named-as-default, import/no-named-as-default-member
/* eslint-enabled */

const NoNavLayout = ({ body, t }) => (
  <div className="app">
    <header>
      <div className="container site-header">
        <div className="logo">
          <img alt="Logo" src={logo} width="114" height="52.81" />
        </div>
        <h1 className="app-title">{t("LayoutApplicationTitle")}</h1>
      </div>
      <div className="container" />
    </header>
    <main>{body}</main>
    <footer />
  </div>
);

NoNavLayout.propTypes = {
  body: PropTypes.object.isRequired
};

export default translate("translations")(connect()(NoNavLayout));



// WEBPACK FOOTER //
// ./src/layout/NoNavLayout.js